<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form :inline="true" class="form-inlines">
                <el-form-item label="医生:">
                    <el-select v-model="formData.docname" placeholder="请选择" size="small" filterable>
                        <el-option v-for="item in  formData.doc_options" :key="item.id" :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="values" type="daterange" size="small" :clearable="false"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="search_day">日对比</el-button>
                    <el-button type="primary" size="small" @click="submitTime(1)">昨</el-button>
                    <el-button type="primary" size="small" @click="submitTime(3)">3</el-button>
                    <el-button type="primary" size="small" @click="submitTime(7)">7</el-button>
                    <el-button type="primary" size="small" @click="submitTimeBy">本月</el-button>
                    <el-button type="primary" size="small" @click="submitTimeSy">上月</el-button>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="zdb_value1" size="small" type="week" format="yyyy 第 WW 周" ref="week1"
                        placeholder="开始周" value-format="yyyy-MM-dd" :clearable="false" id="week1" class="zwidth">
                    </el-date-picker>
                    <el-date-picker v-model="zdb_value2" size="small" type="week" format="yyyy 第 WW 周" ref="week2"
                        placeholder="结束周" value-format="yyyy-MM-dd" :clearable="false" id="week2" class="zwidth">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="search_week">周对比</el-button>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="ydb_value1" size="small" type="month" placeholder="开始月" class="ywidth"
                        value-format="yyyy-MM" :clearable="false" id="month1"></el-date-picker>
                    <el-date-picker v-model="ydb_value2" size="small" type="month" placeholder="结束月" class="ywidth"
                        value-format="yyyy-MM" :clearable="false" id="month2"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="search_month">月对比</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-printer" size="small" plain @click="openExportExcel">
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" v-loading="loading" border :height="Heighttab" ref="table">
                <el-table-column v-for="(item,ind) in header" :key="ind" :label="item.name" align="center">
                    <el-table-column v-show="item.child.length>0" v-for="iteme in item.child" :prop="iteme.key"
                        :key="iteme.key" :label="iteme.name" align="center">
                        <el-table-column v-show="iteme.child.length>0" v-for="itemed in iteme.child" :prop="itemed.key"
                            :key="itemed.key" :label="itemed.name" align="center">
                        </el-table-column>
                        <template slot-scope="{row}" v-if="iteme.child.length<1">
                            {{row[iteme.key]}}
                        </template>
                    </el-table-column>
                    <template slot-scope="{row}" v-if="item.child.length<1">
                        {{row[item.key]}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 导出 -->
        <el-dialog title="导出数据" :visible.sync="exportModal" center width="40%">
            <el-form :model="exportForm" ref="exportForm" label-width="80px">
                <el-form-item label="类型">
                    <el-radio-group v-model="exportForm.radio">
                        <el-radio :label="1">日</el-radio>
                        <el-radio :label="3">周</el-radio>
                        <el-radio :label="2">月</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="时间范围" required>
                    <template v-if="exportForm.radio==1">
                        <!-- <el-date-picker size="small" v-model="exportForm.time" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                        </el-date-picker> -->
                        <el-date-picker v-model="exportForm.time1" size="small" value-format="yyyy-MM-dd" type="date"
                            placeholder="选择开始日期">
                        </el-date-picker>
                        <el-date-picker v-model="exportForm.time2" size="small" value-format="yyyy-MM-dd" type="date"
                            placeholder="选择结束日期">
                        </el-date-picker>
                    </template>
                    <template v-if="exportForm.radio==3">
                        <el-date-picker v-model="exportForm.time1" size="small" type="week" format="yyyy 第 WW 周"
                            ref="week1" placeholder="开始周" value-format="yyyy-MM-dd" :clearable="false" id="week1"
                            class="zwidth">
                        </el-date-picker>
                        <el-date-picker v-model="exportForm.time2" size="small" type="week" format="yyyy 第 WW 周"
                            ref="week2" placeholder="结束周" value-format="yyyy-MM-dd" :clearable="false" id="week2"
                            class="zwidth">
                        </el-date-picker>
                    </template>
                    <template v-if="exportForm.radio==2">
                        <el-date-picker v-model="exportForm.time1" size="small" type="month" placeholder="开始月"
                            class="ywidth" value-format="yyyy-MM" :clearable="false" id="month1"></el-date-picker>
                        <el-date-picker v-model="exportForm.time2" size="small" type="month" placeholder="结束月"
                            class="ywidth" value-format="yyyy-MM" :clearable="false" id="month2"></el-date-picker>
                    </template>


                </el-form-item>
                <el-form-item label="医生" required>
                    <el-select v-model="exportForm.docname" placeholder="请选择" size="small" filterable clearable>
                        <el-option v-for="item in  formData.doc_options" :key="item.id" :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exportModal = false">取 消</el-button>
                <el-button type="primary" :loading='exporloading' @click="exportExcel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                values: [],
                zdb_value1: '',
                zdb_value2: '',
                ydb_value1: '',
                ydb_value2: '',
                loading: false,
                header: [],
                tableData: [],
                Heighttab: null,
                formData: {
                    docname: '',
                    doc_options: [],
                },
                exportModal: false,
                exportForm: {
                    time: [],
                    docname: '',
                    radio: 1,
                    zdb_value1: '',
                    zdb_value2: '',
                    ydb_value1: '',
                    ydb_value2: '',
                    time1: '',
                    time2: '',
                },
                exporloading: false,
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        watch: {
            'exportForm.radio'(n, o) {
                this.exportForm.time1 = ''
                this.exportForm.time2 = ''
            }
        },
        created() {

        },
        async mounted() {
            let that = this;
            that.getheight();
            await that.getdoc()
            await that.gettime();
        },
        methods: {
            async gettime() {
                await this.submitTime(30);
            },
            getheight() {
                let that = this;
                that.$nextTick(() => {
                    var titles = that.$refs.titles.offsetHeight
                    that.Heighttab = window.innerHeight - titles - 150 + 'px'
                    window.onresize = () => {
                        var titles = that.$refs.titles.offsetHeight
                        that.Heighttab = window.innerHeight - titles - 150 + 'px'
                    };
                })
            },
            async getdoc() {
                await axios
                    .post("/admin/doctorAssistantList", {
                        type: 9
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.formData.doc_options = response.data.data
                        this.formData.docname = response.data.data[0].id
                    })
                    .catch(error => {})
            },

            search_day() {
                let that = this;
                that.loading = true
                that.header = [];
                that.tableData = [];
                axios.post("/admin/pc/report/docPersonalBusiness", {
                        start_time: that.values[0],
                        end_time: that.values[1],
                        time_type: '1',
                        user_id: this.formData.docname
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.header = response.data.data.header
                        that.tableData = response.data.data.list
                        that.$nextTick(() => {
                            that.$refs.table.doLayout();
                        });
                    })
                    .catch(error => {})
            },
            search_week() {
                let that = this;
                var week1 = this.$refs.week1.displayValue
                var week2 = this.$refs.week2.displayValue
                that.header = [];
                that.tableData = [];
                if (week1 && week2) {
                    that.loading = true
                    var w1 = (week1.split('第 '))[1];
                    w1 = w1.split(' 周')[0];
                    var w2 = (week2.split('第 '))[1];
                    w2 = w2.split(' 周')[0];
                    axios.post("/admin/pc/report/docPersonalBusiness", {
                            start_time: that.zdb_value1,
                            end_time: that.zdb_value2,
                            time_type: '3',
                            user_id: this.formData.docname
                        }, {
                            token: true
                        })
                        .then(response => {
                            that.loading = false
                            that.header = response.data.data.header
                            that.tableData = response.data.data.list
                            that.$nextTick(() => {
                                that.$refs.table.doLayout();
                            });
                        })
                        .catch(error => {})
                } else {
                    this.$message({
                        showClose: true,
                        message: '请先选择第几周',
                        type: 'warning'
                    });
                }
            },
            search_month() {
                let that = this;
                that.loading = true
                that.header = [];
                that.tableData = [];
                if (this.ydb_value1 && this.ydb_value2) {
                    axios.post("/admin/pc/report/docPersonalBusiness", {
                            start_time: that.ydb_value1,
                            end_time: that.ydb_value2,

                            time_type: '2',
                            user_id: this.formData.docname
                        }, {
                            token: true
                        })
                        .then(response => {
                            that.loading = false
                            that.header = response.data.data.header
                            that.tableData = response.data.data.list
                            that.$nextTick(() => {
                                that.$refs.table.doLayout();
                            });
                        })
                        .catch(error => {})
                } else {
                    that.loading = false
                    this.$message({
                        showClose: true,
                        message: '请先选择月份',
                        type: 'warning'
                    });
                }
            },
            //获取n天前时间
            async submitTime(n) {
                //开始时间
                var nowDate = new Date();
                let befDate = new Date(nowDate.getTime() - n * 24 * 3600 * 1000);
                let byear = befDate.getFullYear();
                let bmonth = befDate.getMonth() + 1;
                if (bmonth >= 1 && bmonth <= 9) {
                    bmonth = "0" + bmonth;
                }
                let bday = befDate.getDate();
                if (bday >= 0 && bday <= 9) {
                    bday = "0" + bday;
                }
                //截止时间
                let endDate = new Date(nowDate.getTime() - 1 * 24 * 3600 * 1000);
                let year = endDate.getFullYear();
                let month = endDate.getMonth() + 1;
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                let day = endDate.getDate();
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }

                //赋值
                let that = this;
                that.values = [
                    byear + "-" + bmonth + "-" + bday,
                    year + "-" + month + "-" + day
                ];
                that.search_day();
            },
            //本月
            submitTimeBy() {
                let that = this
                var date = new Date();
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                if (month < 10) month = "0" + month;
                let yuechu = date.getFullYear() + "-" + month + "-" + '01';
                if (day == 1) {
                    that.values = [yuechu, yuechu]
                } else {
                    day = day - 1;
                    if (day < 10) day = "0" + day;
                    let yuedi = date.getFullYear() + "-" + month + "-" + day;
                    that.values = [yuechu, yuedi]
                }
                that.search_day();
            },
            //上月
            submitTimeSy() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth();
                nowDate.setDate(0);
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                let day = nowDate.getDate();
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }
                let endTime = `${year}-${month}-${day}`;
                this.nowTime = endTime; // 当前的时间点
                let befDate = new Date(nowDate.getTime());
                let byear = befDate.getFullYear();
                let bmonth = befDate.getMonth() + 1;
                if (bmonth >= 1 && bmonth <= 9) {
                    bmonth = "0" + bmonth;
                }
                let bday = befDate.getDate();
                if (bday >= 0 && bday <= 9) {
                    bday = "0" + bday;
                }
                let startTime = `${byear}-${bmonth}-${bday}`;
                let that = this;
                that.values = [
                    byear + "-" + bmonth + "-" + "01",
                    byear + "-" + bmonth + "-" + day
                ];
                that.search_day();
            },
            openExportExcel() {
                this.exportModal = true
            },
            exportExcel() {
                if (this.exportForm.time1 == '' || this.exportForm.time2 == '') return this.$message.error('请选择时间范围')
                if (this.exportForm.docname=='')return this.$message.error('请选择医生')
                let val1 = this.exportForm.time1
                let val2 = this.exportForm.time2
                let params = ''
                if (val1 && val2 ) {
                    params += `&starttime=${val1}`
                    params += `&endtime=${val2}`
                }
                let url = `/admin/pc/Excel/docPerBusExcel?user_id=${this.exportForm.docname}&time_type=${this.exportForm.radio}`

                this.exporloading = true
                this.axios.post(url + params, {}, {
                    token: true,
                    responseType: 'blob'
                }).then(res => {
                    if (res.status == 200) {
                        this.exportModal = false
                        let url = window.URL.createObjectURL(new Blob([res.data]))
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        let filename = new Date().getTime() + '.xlsx';
                        link.setAttribute('download', filename)
                        document.body.appendChild(link)
                        link.click()
                    } else if (res.data.code != 200) {
                        this.$message('暂无数据')
                    }
                    this.exporloading = false

                }).catch(err => {
                    this.exporloading = false

                })
            }
        },
    }
</script>

<style lang="scss" scoped>
    .widthfixs {
        width: 160px !important;
    }

    .red {
        color: red;
    }
</style>